import 'angular';

export function AshdownInvoicesService (
  $state,
  $timeout,
  $translate,
  $window,
  API,
  confirm,
  messages,
  sessionObjAPI,
  staticLookup,
  workshopAPI
) {
  var AshdownInvoices = function (invoice, vehicle) {
    this.origin  = sessionObjAPI.base().origin;
    this.Invoice = invoice;
    this.vehicle = vehicle || {};
  };

  AshdownInvoices.prototype.addItems = function() {
    const self     = this;

    confirm.remember($translate.instant('JS_SPACE.INTEGRATIONS.INVOICE_MUST_FIRST_BE_SAVED', { name:'Ashdown Ingram' }), null, 'ashdownInvoicesAutoSave').then(function () {
      return self.Invoice.save();
    }).then(function (invoice) {
      $timeout(function () {
        $window.location.assign(`/ashdown.html?${self.buildQueryString()}`);
      });
    });
  };

  AshdownInvoices.prototype.addToOrder = function() {
    const self = this;

    self.Invoice.save().then(function (invoice) {
      const params = [ sessionObjAPI.company().ashdown_ingram_settings.ashdown_ingram_vendor_id, 0, '*', 'S', 'order_date', 'desc' ];

      self.Invoice.invoice = invoice;

      return workshopAPI.get('/vendors/purchase_order_list', params);

    }).then(function (orders) {
      if (orders.length > 1) {
        return staticLookup(orders, {
          columns: [
            {
              field : 'order_number',
              header: {
                text: $translate.instant('PURCHASE_ORDER_SPACE.ORDER_NUMBER')
              }
            },
            {
              field : 'order_date',
              header: {
                text: $translate.instant('GENERAL_SPACE.FIELD.DATE'),
              },
              pipe: 'globalDate'
            },
            {
              classes: [ 'text-center' ],
              field  : 'total',
              header : {
                classes: [ 'text-center' ],
                text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT'),
              },
              pipe: 'globalCurrency',
            }
          ]
        }).then(function (order) {
          return workshopAPI.get('/invoice/create_ashdown_ingram_order', [self.Invoice.invoice.id, order.id]);
        });
      }
      else if (orders.length === 1) {
        return confirm.custom( {
          message: $translate.instant('JS_SPACE.INTEGRATIONS.STOCK_ORDER_OPEN', {name:"Ashdown Ingram", num: orders[0].order_number }),
          buttons: {
            new: {
              title: $translate.instant('JS_SPACE.INTEGRATIONS.NEW_ORDER'),
              class: 'primary'
            },
            existing: {
              title: $translate.instant('MENU_SPACE.ADD_TO_ORDER'),
              class: 'success'
            }
          }
        }).then(function (answer) {
          return workshopAPI.get('/invoice/create_ashdown_ingram_order', [self.Invoice.invoice.id, (answer === 'new' ? answer: orders[0].id) ] );
        });
      }
      else {
        return confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.CREATE_ORDER', {name:"Ashdown Ingram"}))
          .then(function () {
            return workshopAPI.get('/invoice/create_ashdown_ingram_order', [self.Invoice.invoice.id, 'new'] );
          });
      }
    }).then(function (order) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.ITEMS_ADDED_TO_ORDER'), 'success');

      $state.go('app.purchase-order', {
        id       : order.purchase_order_id,
        vendor_id: sessionObjAPI.company().ashdown_ingram_settings.ashdown_ingram_vendor_id
      });
    }, function (err) {
      messages.error(err);
    });
  };

  AshdownInvoices.prototype.buildQueryString = function() {
    const self = this;
    var queryString = {
      hookUrl: self.hookUrl(),
      HOOKURL: `${API.url}/invoices/add_item_from_ashdown_ingram/${self.Invoice.invoice.id}`,
      invoice_id: self.Invoice.invoice.id,
      type: 'inquiry'
    };

    if (self.vehicle.id) {
      let vehicle = angular.copy(self.vehicle);

      delete vehicle.follow_up_comment;

      queryString.vehicleInfo = angular.toJson(vehicle);

      queryString['NEW_ITEM-CUST_FIELD5[1]'] = self.vehicle.ashdown_ingram_vehicle_id;
      queryString['NEW_ITEM-CUST_FIELD6[1]'] = self.vehicle.make;
      queryString['NEW_ITEM-CUST_FIELD7[1]'] = self.vehicle.model;
    }

    return $.param(queryString);
  };

  AshdownInvoices.prototype.hasSku = function(item) {
    const self = this;

    if (item) {
      return item.ashdown_ingram_sku;
    }

    var items = self.Invoice.invoice.invoice_items_attributes.filter(function (item) {
      return item.ashdown_ingram_sku;
    });

    return items.length;
  };

  AshdownInvoices.prototype.hookUrl = function() {
    const self = this;

    return self.Invoice.invoice.vehicle_id ?
      `${self.origin}workshop.html#/${self.Invoice.invoice.customer_id}/${self.Invoice.invoice.vehicle_id}/invoice/${self.Invoice.invoice.id}`:
      `${self.origin}workshop.html#/${self.Invoice.invoice.customer_id}/invoice/${self.Invoice.invoice.id}`;
  };

  return AshdownInvoices;
}
